import { createSlice } from '@reduxjs/toolkit'
import { EmployeeFiles } from '../types'

// Define the type for the state
interface StateType {
    employeeFileList: EmployeeFiles[] // Corrected type
    currentPage: number
    totalCount: number
}

const formState: StateType = {
    employeeFileList: [],
    currentPage: 1,
    totalCount: 1,
}

const employeeFileSlice = createSlice({
    name: 'employeeFiles',
    initialState: formState,
    reducers: {
        saveEmployeeFileList: (state, action) => {
            ;(state.totalCount = action.payload.totalCount),
                (state.employeeFileList = action.payload.data),
                (state.currentPage = action.payload.currentPage)
        },
        deleteEmployeeFile: (state, action) => {
            state.employeeFileList = state.employeeFileList.filter(
                (item: EmployeeFiles) =>
                    item.employeeFileId !== action.payload.id
            )
        },
        // Uncomment and correct this reducer if needed
        // deleteEmployeeFileFromList: (state, action) => {
        //     state.employeeFileList.key = state.employeeFileList.key.filter(
        //         (item: EmployeeFiles) => item.id !== action.payload.id
        //     )
        // },
    },
})

export default employeeFileSlice.reducer

export const { saveEmployeeFileList, deleteEmployeeFile } =
    employeeFileSlice.actions
